// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cutting-progress-container {
    position: relative;
    height: 100%;
    width: 100%;
    margin: 0rem;
    background-color: var(--color-component-background);
    --animation-top: 11%;
    --animation-right: 82%;
    --animation-bottom: 71%;
    --animation-left: 17%;
}

.image-scissors-container > svg {
    position: absolute;
}

#left-scissor {
    left: 0px;
    animation-name: image-scissor-snip-left;
}

#right-scissor {
    left: 3px;
    animation-name: image-scissor-snip-right;
}

.image-scissors {
    fill: var(--color-component-foreground);
    animation-delay: 0ms;
    animation-duration: 250ms;
    animation-direction: normal;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

.image-scissors-container {
    position: absolute;
    width: auto;
    height: 50%;
    min-height: 24px;
    max-height: 32px;
    offset-anchor: center center;
    animation-name: image-scissors-rotate;
    animation-delay: 0ms;
    animation-duration: 2.2s;
    animation-direction: normal;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

.image-scissors-cut-line {
    position: absolute;
    left: 13%;
    top: 13%;
    right: 14%;
    bottom: 15%;
    border: dashed 2px var(--color-progress);
}

.cutting-progress-text {
    position: absolute;
    color: var(--color-progress);
    font-size: 0.8em;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
}

@keyframes image-scissor-snip-left {
    0% {
        transform: rotate(-10deg);
    }

    50% {
        transform: rotate(10deg)
    }

    100% {
        transform: rotate(-10deg)
    }
}

@keyframes image-scissor-snip-right {
    0% {
        transform: rotate(10deg);
    }

    50% {
        transform: rotate(-10deg)
    }

    100% {
        transform: rotate(10deg)
    }
}

@keyframes image-scissors-rotate {

    0% {
        transform: rotate(360deg);
        left: var(--animation-right);
        top: var(--animation-bottom);
    }

    12.5% {
        transform: rotate(360deg);
        left: var(--animation-right);
        top: var(--animation-top);
    }

    25% {
        transform: rotate(270deg);
        left: var(--animation-right);
        top: var(--animation-top);
    }

    37.5% {
        transform: rotate(270deg);
        left: var(--animation-left);
        top: var(--animation-top);
    }

    50% {
        transform: rotate(180deg);
        left: var(--animation-left);
        top: var(--animation-top);
    }

    62.5% {
        transform: rotate(180deg);
        left: var(--animation-left);
        top: var(--animation-bottom);
    }

    75% {
        transform: rotate(90deg);
        left: var(--animation-left);
        top: var(--animation-bottom);
    }

    87.5% {
        transform: rotate(90deg);
        left: var(--animation-right);
        top: var(--animation-bottom);
    }

    100% {
        transform: rotate(0deg);
        left: var(--animation-right);
        top: var(--animation-bottom);
    }
}
`, "",{"version":3,"sources":["webpack://./src/Controls/Progress/css/CuttingProgress.css"],"names":[],"mappings":"AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,mDAAmD;IACnD,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,uCAAuC;AAC3C;;AAEA;IACI,SAAS;IACT,wCAAwC;AAC5C;;AAEA;IACI,uCAAuC;IACvC,oBAAoB;IACpB,yBAAyB;IACzB,2BAA2B;IAC3B,6BAA6B;IAC7B,mCAAmC;IACnC,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;IAC5B,qCAAqC;IACrC,oBAAoB;IACpB,wBAAwB;IACxB,2BAA2B;IAC3B,6BAA6B;IAC7B,mCAAmC;IACnC,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,gBAAgB;IAChB,SAAS;IACT,QAAQ;IACR,+BAA+B;AACnC;;AAEA;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI;QACI,yBAAyB;QACzB,4BAA4B;QAC5B,4BAA4B;IAChC;;IAEA;QACI,yBAAyB;QACzB,4BAA4B;QAC5B,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;QACzB,4BAA4B;QAC5B,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;QACzB,2BAA2B;QAC3B,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;QACzB,2BAA2B;QAC3B,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;QACzB,2BAA2B;QAC3B,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;QACxB,2BAA2B;QAC3B,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;QACxB,4BAA4B;QAC5B,4BAA4B;IAChC;;IAEA;QACI,uBAAuB;QACvB,4BAA4B;QAC5B,4BAA4B;IAChC;AACJ","sourcesContent":["@import '../../../css/App.css';\r\n\r\n.cutting-progress-container {\r\n    position: relative;\r\n    height: 100%;\r\n    width: 100%;\r\n    margin: 0rem;\r\n    background-color: var(--color-component-background);\r\n    --animation-top: 11%;\r\n    --animation-right: 82%;\r\n    --animation-bottom: 71%;\r\n    --animation-left: 17%;\r\n}\r\n\r\n.image-scissors-container > svg {\r\n    position: absolute;\r\n}\r\n\r\n#left-scissor {\r\n    left: 0px;\r\n    animation-name: image-scissor-snip-left;\r\n}\r\n\r\n#right-scissor {\r\n    left: 3px;\r\n    animation-name: image-scissor-snip-right;\r\n}\r\n\r\n.image-scissors {\r\n    fill: var(--color-component-foreground);\r\n    animation-delay: 0ms;\r\n    animation-duration: 250ms;\r\n    animation-direction: normal;\r\n    animation-fill-mode: forwards;\r\n    animation-iteration-count: infinite;\r\n    animation-timing-function: linear;\r\n}\r\n\r\n.image-scissors-container {\r\n    position: absolute;\r\n    width: auto;\r\n    height: 50%;\r\n    min-height: 24px;\r\n    max-height: 32px;\r\n    offset-anchor: center center;\r\n    animation-name: image-scissors-rotate;\r\n    animation-delay: 0ms;\r\n    animation-duration: 2.2s;\r\n    animation-direction: normal;\r\n    animation-fill-mode: forwards;\r\n    animation-iteration-count: infinite;\r\n    animation-timing-function: linear;\r\n}\r\n\r\n.image-scissors-cut-line {\r\n    position: absolute;\r\n    left: 13%;\r\n    top: 13%;\r\n    right: 14%;\r\n    bottom: 15%;\r\n    border: dashed 2px var(--color-progress);\r\n}\r\n\r\n.cutting-progress-text {\r\n    position: absolute;\r\n    color: var(--color-progress);\r\n    font-size: 0.8em;\r\n    left: 50%;\r\n    top: 50%;\r\n    transform: translate(-50%,-50%);\r\n}\r\n\r\n@keyframes image-scissor-snip-left {\r\n    0% {\r\n        transform: rotate(-10deg);\r\n    }\r\n\r\n    50% {\r\n        transform: rotate(10deg)\r\n    }\r\n\r\n    100% {\r\n        transform: rotate(-10deg)\r\n    }\r\n}\r\n\r\n@keyframes image-scissor-snip-right {\r\n    0% {\r\n        transform: rotate(10deg);\r\n    }\r\n\r\n    50% {\r\n        transform: rotate(-10deg)\r\n    }\r\n\r\n    100% {\r\n        transform: rotate(10deg)\r\n    }\r\n}\r\n\r\n@keyframes image-scissors-rotate {\r\n\r\n    0% {\r\n        transform: rotate(360deg);\r\n        left: var(--animation-right);\r\n        top: var(--animation-bottom);\r\n    }\r\n\r\n    12.5% {\r\n        transform: rotate(360deg);\r\n        left: var(--animation-right);\r\n        top: var(--animation-top);\r\n    }\r\n\r\n    25% {\r\n        transform: rotate(270deg);\r\n        left: var(--animation-right);\r\n        top: var(--animation-top);\r\n    }\r\n\r\n    37.5% {\r\n        transform: rotate(270deg);\r\n        left: var(--animation-left);\r\n        top: var(--animation-top);\r\n    }\r\n\r\n    50% {\r\n        transform: rotate(180deg);\r\n        left: var(--animation-left);\r\n        top: var(--animation-top);\r\n    }\r\n\r\n    62.5% {\r\n        transform: rotate(180deg);\r\n        left: var(--animation-left);\r\n        top: var(--animation-bottom);\r\n    }\r\n\r\n    75% {\r\n        transform: rotate(90deg);\r\n        left: var(--animation-left);\r\n        top: var(--animation-bottom);\r\n    }\r\n\r\n    87.5% {\r\n        transform: rotate(90deg);\r\n        left: var(--animation-right);\r\n        top: var(--animation-bottom);\r\n    }\r\n\r\n    100% {\r\n        transform: rotate(0deg);\r\n        left: var(--animation-right);\r\n        top: var(--animation-bottom);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
